import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import './styles.css'; // custom themes — loaded before Tailwind, like the original (CDN injected Tailwind last)
import './tailwind.css';
import { initTheme } from './lib/theme';
import App from './App';

initTheme();

// Note: <StrictMode> is intentionally not used — the live map controllers must initialise exactly once.
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
